import axios from "axios";
import authHeader from "@/services/auth-header";

class OrganizationService {
  get() {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Organization`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getRelatedOrganizationList() {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Organization/RelatedOrganizationList`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getOne(organizationId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Organization/${organizationId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getOrganizationDetail(organizationId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Organization/Detail?organizationId=${organizationId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getOrganizationByNMLS(nmls) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Organization/ByNMLS?nmls=${nmls}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getChildOrganizations() {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/Organization/ChildOrganizations`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new OrganizationService();
